var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5C068C"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.96,
    d: "M.48 5.524h17.71v8.442c0 1.06-.86 1.92-1.922 1.92H2.401a1.92 1.92 0 0 1-1.92-1.92zM18.19 5.373H.48V4.21c0-1.06.86-1.92 1.921-1.92H16.27c1.06 0 1.92.86 1.92 1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.441,
    d: "M4.445 1v2.426"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 0.96,
    d: "M2.667 13.132h2.667M2.667 10.706h2.667M8.001 13.132h2.667M8.001 10.706h2.667M8.001 8.28h2.667M13.336 13.132h2.667M13.336 10.706h2.667M13.336 8.28h2.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.441,
    d: "M14.224 1v2.426"
  }))));
};
export default SvgCalendar;